import { trackEvent } from './analyticsService.ts';
import { supabase } from './supabaseService.ts';

export const createCheckoutSession = async (priceId: string, userId: string, billingCycle: 'monthly' | 'yearly', userEmail?: string) => {
  try {
    trackEvent('stripe_checkout_start', { priceId, billingCycle });
    
    const response = await fetch('/api/stripe-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceId,
        userId,
        billingCycle,
        userEmail
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create checkout session');
    }

    if (data.url) {
      // Redirect to Stripe Checkout
      window.location.href = data.url;
    } else {
      throw new Error('No checkout URL received');
    }
  } catch (error: any) {
    console.error('Stripe Error:', error);
    alert('Something went wrong with the payment system. Please try again.');
    trackEvent('stripe_checkout_error', { error: error.message });
  }
};

export const createPortalSession = async (userId: string) => {
  try {
    trackEvent('stripe_portal_access', { userId });
    
    const response = await fetch('/api/stripe-portal', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create portal session');
    }

    if (data.url) {
      // Redirect to Stripe Customer Portal
      window.location.href = data.url;
    } else {
      throw new Error('No portal URL received');
    }
  } catch (error: any) {
    console.error('Stripe Portal Error:', error);
    alert('Unable to access customer portal. Please try again.');
    trackEvent('stripe_portal_error', { error: error.message });
  }
};

export const verifyCheckoutSession = async (sessionId: string) => {
  try {
    const response = await fetch('/api/stripe-verify-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to verify session');
    }

    return data;
  } catch (error: any) {
    console.error('Verify Session Error:', error);
    throw error;
  }
};

export const getSubscriptionStatus = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('is_pro, subscription_status, customer_id, price_id')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error fetching subscription status:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('Get Subscription Status Error:', error);
    return null;
  }
};
